import { observable, when } from '@legendapp/state';

export enum DeviceType {
	iPhone = 'iPhone',
	Android = 'Android',
	iPad = 'iPad',
	Desktop = 'Desktop'
}

export enum DeviceOrientation {
	Portrait = 'Portrait',
	Landscape = 'Landscape'
}

interface DeviceSettingStore {
	isMobileDevice: boolean;
	isTouchDevice: boolean;
	deviceType: DeviceType;
	deviceOrientation: DeviceOrientation;
	isPortrait: boolean;
	isLandscape: boolean;
	screenWidth: number;
	screenHeight: number;
	orientationAngle: number;
}

export const deviceSettingStore = observable<DeviceSettingStore>({
	isMobileDevice: false,
	isTouchDevice: false,
	deviceType: DeviceType.Desktop,
	deviceOrientation: DeviceOrientation.Landscape,
	isPortrait: false,
	isLandscape: false,
	screenWidth: 0,
	screenHeight: 0,
	orientationAngle: 0
});

function updateDeviceType() {
	const userAgent = (str: RegExp) => navigator.userAgent.match(str);
	const isIphone = userAgent(/iphone|iPhone/i) ? DeviceType.iPhone : null;
	const isAndroid = userAgent(/android|Android/i) ? DeviceType.Android : null;
	const isIpad = userAgent(/Macintosh/i) && 'ontouchend' in document ? DeviceType.iPad : null;

	deviceSettingStore.isMobileDevice.set(!!isIphone || !!isAndroid || !!isIpad);
	deviceSettingStore.deviceType.set(isIphone || isAndroid || isIpad || DeviceType.Desktop);
	deviceSettingStore.isTouchDevice.set('ontouchstart' in window || navigator.maxTouchPoints > 0);
}

when(
	() => typeof window !== 'undefined' && typeof navigator !== 'undefined',
	() => {
		updateDeviceType();
		deviceSettingStore.screenWidth.set(window.innerWidth);
		deviceSettingStore.screenHeight.set(window.innerHeight);

		// set basic dimensions
		deviceSettingStore.screenWidth.set(window.innerWidth);
		deviceSettingStore.screenHeight.set(window.innerHeight);

		const portraitQuery = window.matchMedia('(orientation: portrait)');

		const isPortrait = portraitQuery.matches;
		deviceSettingStore.deviceOrientation.set(isPortrait ? DeviceOrientation.Portrait : DeviceOrientation.Landscape);
		deviceSettingStore.isPortrait.set(isPortrait);
		deviceSettingStore.isLandscape.set(!isPortrait);

		const handleOrientationChange = () => {
			const isPortrait = portraitQuery.matches;
			deviceSettingStore.deviceOrientation.set(isPortrait ? DeviceOrientation.Portrait : DeviceOrientation.Landscape);
			deviceSettingStore.isPortrait.set(isPortrait);
			deviceSettingStore.isLandscape.set(!isPortrait);
			deviceSettingStore.screenWidth.set(window.innerWidth);
			deviceSettingStore.screenHeight.set(window.innerHeight);
			deviceSettingStore.orientationAngle.set(window.screen.orientation.angle);
		};

		function handleResize() {
			// We would like to update also when device changes (ex: console emulator)
			updateDeviceType();
			deviceSettingStore.screenWidth.set(window.innerWidth);
			deviceSettingStore.screenHeight.set(window.innerHeight);
		}

		window.addEventListener('resize', handleResize);
		portraitQuery.addEventListener('change', handleOrientationChange);

		return () => {
			window.removeEventListener('resize', handleResize);
			portraitQuery.removeEventListener('change', handleOrientationChange);
		};
	}
);
